export const CHAT_SLOW_NOTICE_MS = 20000;
// Product and shade retrieval can legitimately run longer than 75 seconds.
// Keep a finite browser guard, but do not abort work the backend is still
// completing at the old 75-second boundary.
export const CHAT_REQUEST_TIMEOUT_MS = 120000;

export const isScrollNearBottom = ({ scrollTop, scrollHeight, clientHeight }, threshold = 100) =>
  scrollHeight - scrollTop - clientHeight < threshold;

// The chat lives inside its own scrollable flex child. Using scrollIntoView on
// an element inside that child can also move the page/visual viewport on mobile
// browsers, especially while the keyboard or a fixed sheet is changing size.
// Move only the chat list so the browser never has to choose which ancestor to
// scroll.
export const scrollChatToBottom = (container, behavior = 'auto') => {
  if (!container) return;
  const top = container.scrollHeight;
  if (behavior === 'smooth' && typeof container.scrollTo === 'function') {
    container.scrollTo({ top, behavior: 'smooth' });
    return;
  }
  container.scrollTop = top;
};

export const createRequestTimeout = ({
  timeoutMs = CHAT_REQUEST_TIMEOUT_MS,
  slowAfterMs = CHAT_SLOW_NOTICE_MS,
  onSlow,
} = {}) => {
  const controller = new AbortController();
  let timedOut = false;

  const slowTimer = typeof onSlow === 'function'
    ? setTimeout(onSlow, slowAfterMs)
    : null;
  const timeoutTimer = setTimeout(() => {
    timedOut = true;
    controller.abort();
  }, timeoutMs);

  return {
    signal: controller.signal,
    abort: () => controller.abort(),
    didTimeout: () => timedOut,
    clear: () => {
      if (slowTimer !== null) clearTimeout(slowTimer);
      clearTimeout(timeoutTimer);
    },
  };
};
